import { createI18n } from 'vue-i18n';
import { Locales } from '../locales/locales';

export const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages: Locales.messages,
});
